module.exports = __webpack_public_path__ + "static/media/icon_188.5ce5f372.svg";